import { ConfigProvider } from "antd";
import { ErrorBoundary } from "react-error-boundary";

import { RouterProvider } from "react-router-dom";

import { ErrorFallback } from "@widgets/errorFallback";

import router from "@app/router";
import { getTheme, ThemeProvider, useTheme } from "@shared/ui/theme";
import { Toaster } from "@shared/ui/Toaster";
import { UnauthorizedModal } from "@shared/ui/UnauthorizedModal/UnauthorizedModal";
import QueryClientProvider from "../providers/QueryClientProvider";

import { AuthProvider } from "@entities/auth";

const AppContent = () => {
  const { mode } = useTheme();

  return (
    <ConfigProvider theme={getTheme(mode)}>
      <QueryClientProvider>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <AuthProvider>
            <RouterProvider router={router} />
            <Toaster />
            <UnauthorizedModal />
          </AuthProvider>
        </ErrorBoundary>
      </QueryClientProvider>
    </ConfigProvider>
  );
};

const App = () => (
  <ThemeProvider>
    <AppContent />
  </ThemeProvider>
);

export default App;
